import { axiosInstance } from "./";

const employeesList = async ({ params }) =>
  await axiosInstance.get("/api/Employee/Get", {
    params,
    paramsSerializer: { indexes: null }
  });

const addEmployee = async (data) =>
  await axiosInstance.post("/api/Employee/Add", data);

const employeeDetails = async (params) =>
  await axiosInstance.get(`/api/Employee/View`, { params });

const editEmployee = async (data) =>
  await axiosInstance.post("/api/Employee/Edit", data);

const activateEmployee = async (params) =>
  await axiosInstance.get("/api/Employee/Activate", { params });

const deactivateEmployee = async (params) =>
  await axiosInstance.get("/api/Employee/Deactivate", { params });

export {
  employeesList,
  addEmployee,
  employeeDetails,
  editEmployee,
  activateEmployee,
  deactivateEmployee
};
